var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.totalJobCount > 0 || _vm.editable) ? _c('section', {
    staticClass: "company__section company__section--work"
  }, [_c('header', [_c('section', [_c('h2', {
    staticClass: "section-heading"
  }, [_vm._v(_vm._s(_vm.totalJobCount === 1 ?
    _vm.I18n.t('job_openings_at_company', {
      name: _vm.company.name
    }) :
    _vm.I18n.t('num_job_openings_at_company', {
      name: _vm.company.name,
      num: _vm.totalJobCount
    })))]), _vm._v(" "), (_vm.editable) ? _c('span', [_c('a', {
    staticClass: "pill-button",
    attrs: {
      "href": ("/companies/" + (_vm.company.slug) + "/jobs/new")
    }
  }, [_c('span', {
    staticClass: "pill-button__text"
  }, [_vm._v(_vm._s(_vm.I18n.t('create_job_post')))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (_vm.atsProvider) ? _c('a', {
    staticClass: "pill-button",
    attrs: {
      "href": ("/companies/" + (_vm.company.slug) + "/disconnect_ats"),
      "rel": "nofollow",
      "data-method": "post",
      "data-confirm": _vm.I18n.t('confirm_gallery_disconnect')
    }
  }, [_c('span', {
    staticClass: "pill-button__text"
  }, [_vm._v(_vm._s(("Disconnect " + _vm.atsProvider)))]), _vm._v(" "), _vm._m(1)]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "jobs"
  }, _vm._l((_vm.jobs), function(job, n) {
    return _c('div', {
      staticClass: "company__job"
    }, [(_vm.editable) ? _c('a', {
      staticClass: "company__job__edit",
      attrs: {
        "href": ("/companies/" + (_vm.company.slug) + "/jobs/" + (job.id) + "/edit")
      }
    }, [_c('i', {
      staticClass: "ss-icon"
    }, [_vm._v("compose")])]) : _vm._e(), _vm._v(" "), _c('a', {
      staticClass: "company__job__link",
      attrs: {
        "href": ("/companies/" + (_vm.company.slug) + "/jobs/" + (job.id) + "/click")
      }
    }, [_c('div', {
      staticClass: "company__job__info"
    }, [_c('span', {
      staticClass: "company__job__title"
    }, [_vm._v(_vm._s(job.title))]), _vm._v(" "), _c('time', {
      staticClass: "company__job__timestamp",
      attrs: {
        "datetime": job.created_at
      }
    }, [_vm._v(_vm._s(_vm.formatTimeAgo(job.created_at)) + " ago")])]), _vm._v(" "), _c('div', {
      staticClass: "company__job__details"
    }, [_c('div', {
      staticClass: "company__job__location-details"
    }, [(job.location && !job.remote) ? _c('div', {
      staticClass: "company__job__location"
    }, [_vm._v(_vm._s(job.location))]) : _vm._e(), _vm._v(" "), (job.remote) ? _c('div', {
      staticClass: "company__job__location company__job__location--remote"
    }, [_vm._v("Remote")]) : (job.remote_friendly) ? _c('div', {
      staticClass: "company__job__location company__job__location--remote"
    }, [_vm._v("Remote Friendly")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "company__job__location__icon"
    }, [_vm._v(_vm._s(job.location && !job.remote ? "location" : "wifi"))])]), _vm._v(" "), _c('span', {
      staticClass: "company__job__hours"
    }, [_vm._v(_vm._s(_vm.formatCommitment(job.commitment.name)))])])])])
  })), _vm._v(" "), (_vm.jobs.length < _vm.totalJobCount) ? _c('footer', [(_vm.editable) ? [_c('button', {
    staticClass: "cm-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.fetchNextPage()
      }
    }
  }, [_vm._v("More")]), _vm._v(" "), _c('button', {
    staticClass: "cm-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.fetchAll()
      }
    }
  }, [_vm._v(_vm._s(_vm.I18n.t('view_all_num_jobs', {
    num: _vm.totalJobCount
  })))])] : [_c('a', {
    staticClass: "cm-button",
    attrs: {
      "href": ("/jobs?company_id=" + (_vm.company.id))
    }
  }, [_vm._v("\n        " + _vm._s(_vm.I18n.t('view_all_num_jobs', {
    num: _vm.totalJobCount
  })) + "\n      ")])]], 2) : _vm._e()]) : _vm._e()
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pill-button__icon"
  }, [_c('i', {
    staticClass: "ss-icon"
  }, [_vm._v("add")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pill-button__icon"
  }, [_c('i', {
    staticClass: "ss-icon"
  }, [_vm._v("delete")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ae4b6b0e","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/company/jobs.vue
// module id = null
// module chunks = 